export type AiModelSuggestions = {
  openai: string[];
  azure: string[];
  ollama: string[];
  modelrouter: string[];
  fromSettings: string[];
};

/**
 * Merges static presets with `/api/ai/model-suggestions` (settings + provider configs + agents).
 * `provider` is the companion/agent UI value (`openai` | `azure` | `ollama` or agent variants mapped to openai list).
 */
export function mergeModelOptionsForUiProvider(
  provider: string,
  suggestions: AiModelSuggestions | null,
  staticPresets: readonly string[]
): string[] {
  const settings = suggestions?.fromSettings ?? [];
  let fromCredentials: string[] = [];
  if (provider === 'azure') fromCredentials = suggestions?.azure ?? [];
  else if (provider === 'ollama') fromCredentials = suggestions?.ollama ?? [];
  else if (provider === 'modelrouter') fromCredentials = suggestions?.modelrouter ?? [];
  else fromCredentials = suggestions?.openai ?? [];
  return [...new Set([...staticPresets, ...fromCredentials, ...settings])].sort((a, b) => a.localeCompare(b));
}
